import type { PurchaseSupplierConfig } from '../../../domain/types/configs/company/PurchaseSupplierConfig';

export const purchaseSupplierConfig: PurchaseSupplierConfig = {
  suppliers: [
    {
      company: "01",
      code: "EA31"
    },
    {
      code: "EB23",
      company: "01"
    },
    {
      code: "EB28",
      company: "01"
    },
    {
      company: "01",
      code: "EF07"
    },
    {
      company: "01",
      code: "EF12"
    },
    {
      company: "01",
      code: "EF37"
    },
    {
      company: "01",
      code: "EG03"
    },
    {
      code: "EG15",
      company: "01"
    },
    {
      code: "EG24",
      company: "01"
    },
    {
      company: "01",
      code: "EG36"
    },
    {
      code: "EH20",
      company: "01"
    },
    {
      code: "EI19",
      company: "01"
    },
    {
      company: "01",
      code: "EK01"
    },
    {
      company: "01",
      code: "EK18"
    },
    {
      code: "EM07",
      company: "01"
    },
    {
      code: "ES32",
      company: "01"
    },
    {
      code: "ET11",
      company: "01"
    },
    {
      company: "01",
      code: "EU15"
    },
    {
      code: "ES62",
      company: "01"
    },
    {
      company: "01",
      code: "EP46"
    },
    {
      code: "EC61",
      company: "01"
    },
    {
      code: "RP09",
      company: "01"
    },
    {
      code: "ES90",
      company: "01"
    },
    {
      company: "01",
      code: "EC85"
    },
    {
      code: "EC83",
      company: "01"
    },
    {
      company: "01",
      code: "EF31"
    },
    {
      company: "01",
      code: "EQ07"
    },
    {
      code: "008381",
      company: "01"
    },
    {
      code: "EC66",
      company: "01"
    },
    {
      code: "009405",
      company: "01"
    },
    {
      company: "01",
      code: "009392"
    },
    {
      company: "01",
      code: "ES105"
    },
    {
      code: "EA57",
      company: "01"
    },
    {
      company: "01",
      code: "EM97"
    },
    {
      company: "01",
      code: "EZ04"
    },
    {
      code: "RP02",
      company: "01"
    },
    {
      company: "01",
      code: "EA31"
    },
    {
      company: "01",
      code: "ET11"
    },
    {
      company: "01",
      code: "EK01"
    },
    {
      company: "01",
      code: "EK18"
    },
    {
      company: "01",
      code: "009303"
    },
    {
      company: "01",
      code: "EK22"
    },
    {
      code: "EA79",
      company: "01"
    },
    {
      code: "EI44",
      company: "01"
    },
    {
      company: "01",
      code: "EK13"
    },
    {
      company: "01",
      code: "EH17"
    },
    {
      company: "01",
      code: "ET46"
    },
    {
      code: "EL45",
      company: "01"
    },
    {
      code: "EA72",
      company: "01"
    },
    {
      company: "01",
      code: "ET50"
    },
    {
      code: "EE15",
      company: "01"
    },
    {
      company: "01",
      code: "EB84"
    },
    {
      code: "EC62",
      company: "01"
    },
    {
      code: "EB56",
      company: "01"
    },
    {
      code: "EC91",
      company: "01"
    },
    {
      code: "EO32",
      company: "01"
    },
    {
      company: "01",
      code: "EC84"
    },
    {
      code: "EP60",
      company: "01"
    },
    {
      company: "01",
      code: "EP53"
    },
    {
      code: "EA04",
      company: "01"
    },
    {
      company: "01",
      code: "ER23"
    },
    {
      code: "EI57",
      company: "01"
    },
    {
      code: "EG41",
      company: "01"
    },
    {
      company: "01",
      code: "ES78"
    },
    {
      code: "EL39",
      company: "01"
    },
    {
      code: "EF24",
      company: "01"
    },
    {
      company: "01",
      code: "EC37"
    },
    {
      code: "EP49",
      company: "01"
    },
    {
      company: "01",
      code: "ES91"
    },
    {
      company: "01",
      code: "EL46"
    },
    {
      company: "01",
      code: "EV26"
    },
    {
      code: "EA100",
      company: "01"
    },
    {
      code: "9329",
      company: "01"
    },
    {
      company: "01",
      code: "9051"
    },
    {
      company: "01",
      code: "9173"
    },
    {
      code: "7250",
      company: "01"
    },
    {
      code: "9140",
      company: "01"
    },
    {
      code: "9152",
      company: "01"
    },
    {
      code: "RP03",
      company: "01"
    },
    {
      company: "01",
      code: "6354"
    },
    {
      company: "01",
      code: "9483"
    },
    {
      company: "01",
      code: "ES102"
    },
    {
      code: "EQ09",
      company: "01"
    },
    {
      company: "01",
      code: "ET47"
    },
    {
      code: "9269",
      company: "01"
    },
    {
      company: "01",
      code: "EM86"
    },
    {
      code: "EF07",
      company: "01"
    },
    {
      company: "01",
      code: "EF37"
    },
    {
      code: "RP10",
      company: "01"
    },
    {
      code: "RP01",
      company: "01"
    },
    {
      company: "01",
      code: "EB23"
    },
    {
      company: "01",
      code: "ES32"
    },
    {
      code: "EH20",
      company: "01"
    },
    {
      code: "EG03",
      company: "01"
    },
    {
      code: "ES48",
      company: "01"
    },
    {
      company: "01",
      code: "EG24"
    },
    {
      company: "01",
      code: "9609"
    },
    {
      company: "01",
      code: "9682"
    },
    {
      code: "EC59",
      company: "01"
    },
    {
      company: "01",
      code: "EI46"
    },
    {
      code: "EL27",
      company: "01"
    },
    {
      code: "EM70",
      company: "01"
    },
    {
      company: "01",
      code: "EV08"
    },
    {
      code: "EG23",
      company: "01"
    },
    {
      code: "EB67",
      company: "01"
    },
    {
      company: "01",
      code: "ES54"
    },
    {
      company: "01",
      code: "EK07"
    },
    {
      code: "EV22",
      company: "01"
    },
    {
      code: "ES93",
      company: "01"
    },
    {
      code: "EV15",
      company: "01"
    },
    {
      company: "01",
      code: "7220"
    },
    {
      code: "EM103",
      company: "01"
    },
    {
      code: "EI52",
      company: "01"
    },
    {
      code: "EC80",
      company: "01"
    },
    {
      code: "EC18",
      company: "01"
    },
    {
      company: "01",
      code: "ET24"
    },
    {
      company: "01",
      code: "EA82"
    },
    {
      company: "01",
      code: "ER28"
    },
    {
      code: "EB82",
      company: "01"
    },
    {
      code: "EB81",
      company: "01"
    },
    {
      code: "EC74",
      company: "01"
    },
    {
      company: "01",
      code: "EH46"
    },
    {
      code: "EA101",
      company: "01"
    },
    {
      company: "01",
      code: "EC94"
    },
    {
      company: "01",
      code: "ER17"
    },
    {
      company: "01",
      code: "EI62"
    },
    {
      code: "9052",
      company: "01"
    },
    {
      code: "9087",
      company: "01"
    },
    {
      company: "01",
      code: "9123"
    },
    {
      code: "9162",
      company: "01"
    },
    {
      code: "ED40",
      company: "01"
    },
    {
      company: "01",
      code: "9533"
    },
    {
      company: "01",
      code: "2594"
    },
    {
      company: "01",
      code: "EH38"
    },
    {
      company: "01",
      code: "9481"
    },
    {
      company: "01",
      code: "ER18"
    },
    {
      company: "01",
      code: "9772"
    },
    {
      company: "01",
      code: "EG48"
    },
    {
      company: "01",
      code: "EB69"
    },
    {
      code: "EM07",
      company: "01"
    },
    {
      company: "01",
      code: "EI19"
    },
    {
      code: "EF12",
      company: "01"
    },
    {
      company: "01",
      code: "EB50"
    },
    {
      company: "01",
      code: "EB28"
    },
    {
      company: "01",
      code: "EG36"
    },
    {
      company: "01",
      code: "ES104"
    },
    {
      company: "01",
      code: "EA99"
    },
    {
      company: "01",
      code: "EC93"
    },
    {
      code: "EC98",
      company: "01"
    },
    {
      code: "EG32",
      company: "01"
    },
    {
      code: "EL26",
      company: "01"
    },
    {
      company: "01",
      code: "EL40"
    },
    {
      code: "EM69",
      company: "01"
    },
    {
      company: "01",
      code: "EZ02"
    },
    {
      code: "EA105",
      company: "01"
    },
    {
      code: "EN16",
      company: "01"
    },
    {
      code: "EV21",
      company: "01"
    },
    {
      company: "01",
      code: "EC54"
    },
    {
      company: "01",
      code: "EI40"
    },
    {
      company: "01",
      code: "EL21"
    },
    {
      company: "01",
      code: "EF10"
    },
    {
      company: "01",
      code: "EW05"
    },
    {
      company: "01",
      code: "EK17"
    },
    {
      code: "EM80",
      company: "01"
    },
    {
      code: "8457",
      company: "01"
    },
    {
      code: "EB76",
      company: "01"
    },
    {
      code: "EN19",
      company: "01"
    },
    {
      code: "8773",
      company: "01"
    },
    {
      company: "01",
      code: "EC42"
    },
    {
      code: "EM35",
      company: "01"
    },
    {
      company: "01",
      code: "EE39"
    },
    {
      code: "EB62",
      company: "01"
    },
    {
      code: "9638",
      company: "01"
    },
    {
      code: "EE06",
      company: "01"
    },
    {
      code: "EM59",
      company: "01"
    },
    {
      company: "01",
      code: "ES96"
    },
    {
      company: "01",
      code: "EH18"
    },
    {
      code: "EA23",
      company: "01"
    },
    {
      code: "EU09",
      company: "01"
    },
    {
      company: "01",
      code: "EN24"
    },
    {
      company: "01",
      code: "EM91"
    },
    {
      company: "01",
      code: "EA55"
    },
    {
      company: "01",
      code: "ER31"
    },
    {
      company: "01",
      code: "EG54"
    },
    {
      company: "01",
      code: "EL43"
    },
    {
      company: "01",
      code: "LE271"
    },
    {
      code: "EK25",
      company: "01"
    },
    {
      company: "01",
      code: "9013"
    },
    {
      code: "9290",
      company: "01"
    },
    {
      code: "8331",
      company: "01"
    },
    {
      company: "01",
      code: "8984"
    },
    {
      code: "RP08",
      company: "01"
    },
    {
      company: "01",
      code: "9656"
    },
    {
      company: "01",
      code: "ED38"
    },
    {
      company: "01",
      code: "EU15"
    },
    {
      company: "01",
      code: "9256"
    },
    {
      company: "01",
      code: "EM96"
    },
    {
      code: "9391",
      company: "01"
    },
    {
      company: "01",
      code: "8767"
    },
    {
      company: "01",
      code: "ED01"
    },
    {
      code: "ED36",
      company: "01"
    },
    {
      code: "EE30",
      company: "01"
    },
    {
      code: "EG15",
      company: "01"
    },
    {
      code: "EL32",
      company: "01"
    },
    {
      code: "EO02",
      company: "01"
    },
    {
      company: "01",
      code: "ES80"
    },
    {
      code: "ES39",
      company: "01"
    },
    {
      company: "01",
      code: "EB29"
    },
    {
      company: "01",
      code: "8349"
    },
    {
      code: "EA64",
      company: "01"
    },
    {
      company: "01",
      code: "ES04"
    },
    {
      company: "01",
      code: "EE16"
    },
    {
      code: "ET53",
      company: "01"
    },
    {
      code: "9439",
      company: "01"
    },
    {
      company: "01",
      code: "EN02"
    },
    {
      company: "01",
      code: "EB73"
    },
    {
      company: "01",
      code: "EF16"
    },
    {
      company: "01",
      code: "EM84"
    },
    {
      company: "01",
      code: "9050"
    },
    {
      company: "01",
      code: "EH44"
    },
    {
      company: "01",
      code: "EB86"
    },
    {
      code: "EH36",
      company: "01"
    }
  ]
}; 